import { API_BASE_URL } from "../services/apiBase";
import { forwardToPixel } from "./metaPixel";

/**
 * Lightweight analytics dispatch. Records each funnel event on our own
 * backend, and also forwards it to a GTM dataLayer or gtag if one is present.
 *
 * The backend keeps only allowlisted events and properties and hashes the
 * request ID (ayupath-teaser-func/shared/funnel.py). Never pass a name,
 * email, birth detail or report text here.
 */

const SESSION_KEY = "ayupath-session";

function randomId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/** A random ID for this browser tab, so events from one visit can be grouped. */
function sessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = randomId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}

function sendToBackend(event, payload) {
  if (typeof fetch !== "function") return;
  const { requestId, ...props } = payload;
  // text/plain skips the CORS preflight; keepalive lets the event survive
  // the navigation that often follows it (e.g. checkout).
  fetch(`${API_BASE_URL}/event`, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "text/plain" },
    body: JSON.stringify({ event, session_id: sessionId(), request_id: requestId, props }),
  }).catch(() => {});
}

export function track(event, payload = {}) {
  try {
    if (typeof window === "undefined") return;

    sendToBackend(event, payload);
    forwardToPixel(event, payload);

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...payload });
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", event, payload);
    }
  } catch {
    // Analytics must never break the funnel.
  }
}
